import { ApiResponse, getRaw, postRaw } from 'services/api';
import type { WorkflowWebhook } from '../modules/workflowWebhooks/types';

export const WORKFLOW_WEBHOOKS_URL = '/workflows/webhooks.json';
export const CREATE_WORKFLOW_WEBHOOK_URL = '/workflows/webhooks/create';
export const UPDATE_WORKFLOW_WEBHOOK_URL = '/workflows/webhooks/update';
export const DELETE_WORKFLOW_WEBHOOK_URL = '/workflows/webhooks/delete';
export const CLONE_WORKFLOW_WEBHOOK_URL = '/workflows/webhooks/clone';

/**
 * Get endpoint for fetching workflow webhooks
 */
export const fetchWorkflowWebhooks = (): Promise<ApiResponse> => getRaw(WORKFLOW_WEBHOOKS_URL);

/**
 * POST endpoint for creating a workflow webhook
 */
export const createWorkflowWebhook = (webhook: WorkflowWebhook): Promise<ApiResponse> =>
  postRaw(CREATE_WORKFLOW_WEBHOOK_URL, webhook);

/**
 * POST endpoint for updating a workflow webhook
 */
export const updateWorkflowWebhook = (webhook: WorkflowWebhook): Promise<ApiResponse> =>
  postRaw(UPDATE_WORKFLOW_WEBHOOK_URL, webhook);

/**
 * POST endpoint for deleting a workflow webhook by id
 */
export const deleteWorkflowWebhook = (workflowWebhookId: number): Promise<ApiResponse> =>
  postRaw(DELETE_WORKFLOW_WEBHOOK_URL, { workflowWebhookId });

/**
 * POST endpoint for cloning a workflow webhook by id, with optional name
 */
export const cloneWorkflowWebhook = (
  workflowWebhookId: number,
  workflowWebhookName: string,
): Promise<ApiResponse> =>
  postRaw(CLONE_WORKFLOW_WEBHOOK_URL, { workflowWebhookId, workflowWebhookName });
